import { render, staticRenderFns } from "./UiEditorLayout.vue?vue&type=template&id=1c54825a"
import script from "./UiEditorLayout.vue?vue&type=script&lang=js"
export * from "./UiEditorLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports